import { Module } from 'core/Module';
import { Events } from 'core/events/Events';
import { Core } from 'core/Core';
import { template } from 'utils/string';

export class LoadMore extends Module {
	public config = {
		total: null,
		activeCount: 0,
		loadCount: 0,
		imgSrc: '',
		selector: '.load-more__items',
		buttonSelector: 'load-more__button'
	};

	private _$contentContainer: HTMLElement;
	private _$button: HTMLElement;
	private _eventId: number;

	public create(): void {
		this._$contentContainer = this.$container.querySelector(this.config.selector);
		this._$button = document.querySelector(this.config.buttonSelector);
		this._eventId = Events.on('click', this._$button, () => this._loadMore());
	}

	public destroy(): void {
		Events.offById(this._eventId);
		this._$contentContainer = null;
		this._$button = null;
		super.destroy();
	}

	private _loadMore(): void {
		let html: string = '';
		let startCount: number = this.config.activeCount + 1;
		this.config.activeCount =
			startCount + this.config.loadCount < this.config.total ? startCount + this.config.loadCount : this.config.total;

		for (let i = startCount; i <= this.config.activeCount; i++) {
			let imgSrc = template(this.config.imgSrc, { n: i });
			html += this._img(imgSrc);
		}

		Core.DOM.append(this._$contentContainer, html);

		if (this.config.activeCount >= this.config.total) {
			gsap.TweenMax.to(this._$button, 0.5, { autoAlpha: 0 });
		}
	}

	private _img(src: string): string {
		return `<div class='grid__item'>
			<div class='lazy-load-image -ratio-square'>
				<div class="lazy-load-image__inner">
					<img src="${src}">
				</div>
			</div>
		</div>`;
	}
}
